import { render } from "./ModalComponent.vue?vue&type=template&id=bd6f3298&scoped=true&ts=true"
import script from "./ModalComponent.vue?vue&type=script&lang=ts"
export * from "./ModalComponent.vue?vue&type=script&lang=ts"

import "./ModalComponent.vue?vue&type=style&index=0&id=bd6f3298&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd6f3298"]])

export default __exports__